import * as _ from 'lodash-es';

import { Dispatch } from 'redux';

import {
  enqueueSnackbarCustomMessageHandler,
  enqueueSnackbarHandler,
} from '../Status';
import {
  ACTION_GET_TRANSACTIONS_BY_PARAMS,
  ACTION_GET_TRANSACTIONS_BY_PARAMS_FAILURE,
  ACTION_GET_TRANSACTIONS_BY_PARAMS_SUCCESS,
  ACTION_SELECT_TRANSACTION_TABLE_ROW,
  API_CALL,
} from '../../configs/ActionTypes';

export function selectTransactionRow(id: string) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_SELECT_TRANSACTION_TABLE_ROW,
      payload: { id },
    });
  };
}
